<template>
  <svg stroke-linecap="round" version="1.1" viewBox="0 0 10000 12000" xml:space="preserve"
       xmlns="http://www.w3.org/2000/svg"><path  d="M6798.71 1238.69c-335.96,49 -1161.88,132.97 -419.96,468.95 741.91,335.97 1595.83,489.94 419.96,1266.86 -1175.87,776.91 -1770.8,1434.83 -2162.75,2008.77 -391.94,573.94 -846.89,2154.43 -972.88,2574.38 -125.98,419.95 -1350.83,3444.9 -1350.83,3444.9" fill-opacity="0" stroke="#58E2B0" stroke-dasharray="100000" stroke-dashoffset="1000" stroke-miterlimit="22.9526" stroke-width="200px"></path></svg>
</template>

<script lang="ts" setup>
</script>
